import React from 'react';
import { SalesLetter } from './components/SalesLetter';
export function App() {
  return <SalesLetter data-id="element-0" />;
}